<mat-dialog-content>
  <p class="info-message">{{ 'GPT_STORIES.GENERATE_STORIES_INFO_S2_P1' | translate }}</p>
  <form [formGroup]="generateStoriesAIForm" class="generate-stories-form" #form="ngForm">
    <q9-requirement-select formControlName="requirement"></q9-requirement-select>

    <q9-release-select formControlName="release"></q9-release-select>

    <q9-custom-fields-form
      [itemType]="itemType"
      [formGroup]="customFieldsFormGroup"></q9-custom-fields-form>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <q9-secondary-button mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </q9-secondary-button>

  <q9-secondary-button (click)="changeStep.emit(-1)">
    {{ 'POPUPS.SWITCH_BACK' | translate }}
  </q9-secondary-button>

  <q9-primary-button
    [isLoading]="isLoading()"
    [disabled]="disableSubmit"
    (click)="form.onSubmit($event); onSubmit()">
    {{ 'GPT_STORIES.GENERATE_SUBMIT' | translate }}
  </q9-primary-button>
</mat-dialog-actions>
